// A store's own button opens the popup (rules_settings.when_to_show.open_on_click,
// a CSS selector such as "#join-the-rush"; 30 Oct 2026, Carmién's hero button).
// The store only gives the button that ID (Elementor: Advanced > CSS ID); no code.
//
// One listener on the document, in the capture phase, so it also catches buttons
// the page builder adds after load and clicks on anything inside the button (the
// ID often sits on a wrapper around the link). The click opens the popup whatever
// its triggers and the visitor's history say: they asked for it.

let selector: string | null = null;
let opener: (() => void) | null = null;
let installedOn: Document | null = null;

function onClick(event: MouseEvent): void {
  if (!selector || !opener) return;
  const target = event.target as Element | null;
  let hit: Element | null = null;
  try {
    hit = target && typeof target.closest === "function" ? target.closest(selector) : null;
  } catch {
    return; // a selector the browser cannot read: never break the store's page
  }
  if (!hit) return;
  event.preventDefault();
  opener();
}

/** Set (or clear, with an empty value) the selector whose click opens the popup. */
export function setClickTrigger(value: unknown, open: () => void, doc: Document | undefined = globalThis.document): void {
  const next = typeof value === "string" ? value.trim() : "";
  selector = next || null;
  opener = open;
  if (selector && doc && installedOn !== doc) {
    doc.addEventListener("click", onClick, true);
    installedOn = doc;
  }
}

/** Tests only. */
export function resetClickTriggerForTests(): void {
  installedOn?.removeEventListener("click", onClick, true);
  installedOn = null;
  selector = null;
  opener = null;
}
